export default {
  "fontElementMap": "isKq3",
  "hashtag": "WPXMm"
};